import { Link } from 'react-router-dom';
import { LINKEDIN } from '../data/company';
import './footer.css';

const SOCIAL = [
  { href: 'https://github.com/als-ops-llc', label: 'GitHub' },
  { href: 'https://www.youtube.com/channel/UCz4U0gR1xfp6f0Tmk7SzrXA', label: 'YouTube' },
  { href: 'https://www.facebook.com/profile.php?id=61586142746386', label: 'Facebook' },
  { href: 'https://www.producthunt.com/@als_ops_llc', label: 'Product Hunt' },
  { href: 'https://www.g2.com/products/al-s-ops-llc/reviews#reviews', label: 'Reviews on G2' },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo" itemScope itemType="https://schema.org/Organization">
      <meta itemProp="name" content="Al's-Ops LLC" />
      <meta itemProp="foundingDate" content="2023" />
      <meta itemProp="url" content="https://alsopss.com" />
      <meta itemProp="founder" content="Aiden McElroy" />
      <div itemScope itemType="https://schema.org/Person" className="sr-only">
        <meta itemProp="name" content="Aiden McElroy" />
        <meta itemProp="jobTitle" content="Founder & CEO" />
        <meta itemProp="worksFor" content="Al's-Ops LLC" />
        <link itemProp="sameAs" href={LINKEDIN} />
      </div>
      <meta itemProp="telephone" content="+1-833-821-9853" />
      <link itemProp="contactPoint" href="tel:+18338219853" />
      <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress" className="sr-only">
        <span itemProp="addressLocality">Eagle Mountain</span>
        <span itemProp="addressRegion">UT</span>
        <span itemProp="addressCountry">US</span>
      </div>
      {SOCIAL.slice(0, 4).map(s => <link key={s.href} itemProp="sameAs" href={s.href} />)}

      <div className="wrap">
        <div className="footer-top">
          <p className="footer-statement">
            Security and infrastructure software, built independently in Eagle Mountain, Utah.
          </p>
          <div className="footer-trial">
            <a href="https://vigilhold.com/register" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
              Start a Vigilhold trial <span aria-hidden="true">↗</span>
            </a>
            <p>14 days, no card. Verified accounts from $39 a month.</p>
          </div>
        </div>

        <nav className="footer-cols" aria-label="Footer navigation">
          <div>
            <h2 className="footer-h">Products</h2>
            <ul>
              <li><Link to="/products">All products</Link></li>
              <li><a href="https://vigilhold.com" target="_blank" rel="noopener noreferrer">Vigilhold</a></li>
              <li><Link to="/labs">AL'S-OPS Labs</Link></li>
              <li><Link to="/trust">Trust &amp; verification</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="footer-h">Company</h2>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/team">Team</Link></li>
              <li><Link to="/press">Press</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><a href="/llms.txt">llms.txt</a></li>
            </ul>
          </div>
          <div>
            <h2 className="footer-h">Blog</h2>
            <ul>
              <li><Link to="/blog">Overview</Link></li>
              <li><Link to="/blog/articles">Articles</Link></li>
              <li><Link to="/blog/video">Video</Link></li>
              <li><Link to="/research">Research</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="footer-h">Contact</h2>
            <ul>
              <li><a href="tel:+18338219853">833-821-9853</a></li>
              <li><a href="mailto:sales@alsopss.com">sales@alsopss.com</a></li>
              <li><a href="mailto:support@vigilhold.com">support@vigilhold.com</a></li>
              <li><a href={LINKEDIN} target="_blank" rel="noopener noreferrer">Aiden McElroy on LinkedIn</a></li>
            </ul>
          </div>
          <div>
            <h2 className="footer-h">Elsewhere</h2>
            <ul>
              {SOCIAL.map(s => (
                <li key={s.href}><a href={s.href} target="_blank" rel="nofollow noopener noreferrer">{s.label}</a></li>
              ))}
            </ul>
          </div>
        </nav>

        <div className="footer-bottom">
          <p>&copy; {year} Al's-Ops LLC. Founded 2023 by Aiden McElroy. Tomorrow's Solutions, Built Today.</p>
          <p>Set in Overpass, Overpass Mono and Literata.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
